import React, {Suspense, lazy} from 'react';

import {assert} from 'Asserts';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

import {TenantScreens} from './TenantAdminConstants';

interface TenantFullScreenProps {
  currentScreen: string;
}

const TenantAdminPage = lazy(() => import(/* webpackChunkName: "tenant-admin-page" */ './TenantAdminPage'));

function TenantFullScreenView(props: TenantFullScreenProps): JSX.Element | null {
  switch (props.currentScreen) {
    case TenantScreens.TENANT_ADMIN_SCREEN:
      return (
        <Suspense fallback={<CenteredHorizontalThrobber />}>
          <TenantAdminPage />
        </Suspense>
      );
    default:
      assert(false, `TenantFullScreenView called with invalid screen: ${props.currentScreen}`);
      return null;
  }
}

export default TenantFullScreenView;
